<template>
  <div>
    <draggable
      v-model="local_value"
      class="drag-area synaplus-cosmo-scroll-higher-720"
      group="metavariable-type"
      handle=".metavariable-type-handle"
      :sort="editing_nb == -1"
    >
      <metavariable-type-element
        v-for="(val, index) in local_value"
        v-bind="metavariable_type_element_bindings(false, val, index)[0]"
        v-on="metavariable_type_element_bindings(false, val, index)[1]"
        class="mt-2 hand-pointer metavariable-type-handle"
      />
    </draggable>

    <metavariable-type-element
      v-bind="
        metavariable_type_element_bindings(true, new_metavariable_type_entry)[0]
      "
      v-on="
        metavariable_type_element_bindings(true, new_metavariable_type_entry)[1]
      "
      class="mt-4"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import draggable from 'vuedraggable'

import {
  MetavariableTypeAbstractBase,
  FrozenDict,
} from '@/components/object_model.js'
import MetavariableTypeElement from '@/components/metavariable_type_element.vue'

// *****************************************************************************

export default {
  name: 'ProjectAdminSubcomponentMetavariablesTypesEditor',
  components: {
    draggable,
    MetavariableTypeElement,
  },
  props: ['value'],

  data() {
    return {
      local_value: undefined,
      editing_nb: -1,
      new_metavariable_type_entry: {
        typename: '',
        metavariable_type: new MetavariableTypeAbstractBase(),
      },
    }
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, this.local_value)) {
          this.local_value = _.cloneDeep(nv)
        }
      },
    },
    local_value: {
      immediate: true,
      deep: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, this.value)) {
          this.$emit('input', _.cloneDeep(nv))
        }
      },
    },
  },

  methods: {
    add_new_metavariable_type(entry) {
      this.local_value.push(entry)
      this.new_metavariable_type_entry = {
        typename: '',
        metavariable_type: new MetavariableTypeAbstractBase(),
      }
      this.editing_nb = -1
    },

    delete_metavariable_type(index) {
      this.local_value.splice(index, 1)
      this.editing_nb = -1
    },

    validate_metavariable_type_edition(index, entry) {
      Vue.set(this.local_value, index, entry)
      this.remove_potential_duplicate(index, entry)
    },

    remove_potential_duplicate(index, entry) {
      let duplicate_index = _.findIndex(
        this.local_value,
        x => x.typename === entry.typename
      )

      if (duplicate_index !== index) {
        if (duplicate_index > index) {
          duplicate_index += 1
        }
        this.local_value.splice(duplicate_index, 1)
      }
      this.editing_nb = -1
    },

    metavariable_type_element_bindings(is_new_entry, entry, index) {
      let is_new_metavariable_type = is_new_entry
      let in_edition = is_new_entry ? true : this.editing_nb == index

      let bind = { value: entry, is_new_metavariable_type, in_edition }

      let on = is_new_entry
        ? {
            input: this.add_new_metavariable_type.bind(this),
          }
        : {
            start_editing: () => {
              this.editing_nb = index
            },
            delete: () => this.delete_metavariable_type(index),
            input: val => {
              this.validate_metavariable_type_edition(index, val)
            },
          }

      let res = [bind, on]

      return res
    },
  },
}
</script>
